/* PORTAL-106: the stamp card in the Hall of Heroes (Jan, 2026-10-06).
   1. Ticking "I commissioned this portrait from FramedFantasy" in Add a Hero opens a short panel: this portrait can count
      toward a free upgrade on the next portrait, a box (on by default) that sends it to Jan once it is in the Hall, and
      "How the stamp card works".
   2. Your Hall shows the signed-in visitor's stamp card when they have stamps or a hero with the FramedFantasy mark:
      their stamps, how far to the next free upgrade, and each of those heroes with "Count it" or where it stands.
   3. /pages/hall-of-heroes#add-ff-portrait (the order page's "Add it to the Hall") opens Add a Hero with the box ticked.
   It reads the Hall's own sign-in (email and PIN) and calls two Hall actions, hoh_stamps and hoh_stamp_claim, which check
   the PIN like every Hall action. The form, its submit gate, its draft and its tracking are left exactly as they are.
   Jan in god mode can open /pages/hall-of-heroes?stampdemo to see Your Hall's card with example heroes. */
(function () {
  'use strict';
  if (window.hohStamps) return;
  var TOKEN = 'hoh-your-hall-token', PENDING = 'hoh-stamp-pending', WEEK = 7 * 86400000;
  var MARK = 'https://cdn.shopify.com/s/files/1/0884/2389/1261/files/Logo_Clean.webp?v=1775168383&width=64';
  var ORDER_PAGE = '/pages/your-commission', NEXT_PORTRAIT = '/products/returning';
  var GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 12v9H4v-9M12 21v-9"/><path d="M2 7h20v5H2zM12 12V7M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"/></svg>';
  var STAR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l2.6 5.5 6 .8-4.4 4.2 1.1 6L12 16.6 6.7 19.5l1.1-6L3.4 9.3l6-.8z"/></svg>';
  var QUILL = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.5 4.5l5 5L9 20H4v-5z"/><path d="M12.5 6.5l5 5"/></svg>';
  var state = { data: null, email: '', at: 0, busy: false, demo: false, countIt: true };

  function esc(value) { return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  /* HALL-GOOGLE-01: a Google sign-in keeps 'g1.' + a secret where the PIN goes; portal.hall_pin takes either. */
  function session() {
    try {
      var t = JSON.parse(localStorage.getItem(TOKEN) || 'null');
      return t && t.email && /^(\d{4}|g1\.[0-9a-f]{64})$/.test(String(t.pin || '')) ? { email: String(t.email).trim().toLowerCase(), pin: String(t.pin) } : null;
    } catch (_) { return null; }
  }
  function rpc(name, params) {
    var c = window.hohSupabaseClient;
    if (!c || typeof c.rpc !== 'function') return Promise.resolve(null);
    return c.rpc(name, params).then(function (r) { return r && !r.error ? r.data : null; }, function () { return null; });
  }
  function calm() { try { return matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (_) { return false; } }
  function god() { try { return typeof window.hohIsGodMode === 'function' && window.hohIsGodMode(); } catch (_) { return false; } }
  function toast(title, line) { if (typeof window.hohShowHeartToast === 'function') { try { window.hohShowHeartToast(title, line || '', true); } catch (_) {} } }
  function safeImage(url) { return typeof url === 'string' && /^https:\/\//.test(url) ? url : ''; }
  function frameStyle(f) {
    if (!f || !isFinite(f.x) || !isFinite(f.y)) return '';
    return 'object-position:' + Number(f.x) + '% ' + Number(f.y) + '%;' + (f.zoom > 100 ? 'transform:scale(' + Number(f.zoom) / 100 + ');transform-origin:' + Number(f.x) + '% ' + Number(f.y) + '%;' : '');
  }

  /* ---- 1. The panel under the FramedFantasy box ---------------------------------------------------------------- */
  function ffBox() { return document.getElementById('hoh-f-ff-portrait'); }
  function panelHtml() {
    return '<div class="hoh-stamp-panel" id="hoh-stamp-panel" data-wstep="2" role="group" aria-labelledby="hoh-stamp-panel-title">'
      + '<div class="hoh-stamp-panel-seals" aria-hidden="true"><span></span><span></span><span class="is-gift">' + GIFT + '</span></div>'
      + '<div class="hoh-stamp-panel-body">'
      + '<p class="hoh-stamp-panel-title" id="hoh-stamp-panel-title">This portrait can count toward a free upgrade</p>'
      + '<p class="hoh-stamp-panel-text">Jan checks every FramedFantasy portrait by hand. Each one Jan adds is a stamp on your card, and every 3rd stamp earns a free upgrade on your next portrait.</p>'
      + '<label class="hoh-stamp-panel-check"><input type="checkbox" id="hoh-stamp-count"' + (state.countIt ? ' checked' : '') + '><span class="hoh-stamp-panel-box" aria-hidden="true"></span><span>Send it to Jan for my stamp card</span></label>'
      + '<button type="button" class="hoh-stamp-link" data-stamp-how>How the stamp card works</button>'
      + '</div></div>';
  }
  function syncPanel() {
    var box = ffBox(), wrap = document.getElementById('hoh-ff-toggle-wrap'), panel = document.getElementById('hoh-stamp-panel');
    /* HERO-CARD-01: a portrait added from its commission page already has its stamp, so no panel asks for one */
    var show = !!(box && wrap && box.checked && wrap.classList.contains('hoh-ff-visible') && !window.hohEditingCharacterId && !window.hohPortalCard);
    if (show && !panel) {
      wrap.insertAdjacentHTML('afterend', panelHtml());
      panel = document.getElementById('hoh-stamp-panel');
      if (calm()) panel.classList.add('is-open');
      else requestAnimationFrame(function () { requestAnimationFrame(function () { panel.classList.add('is-open'); }); });
    } else if (!show && panel) panel.remove();
  }
  var syncSoon = (function () { var t = null; return function () { clearTimeout(t); t = setTimeout(syncPanel, 30); }; })();

  /* ---- 2. A new FramedFantasy hero goes to Jan once it is in the Hall ------------------------------------------- */
  function readPending() {
    try { return (JSON.parse(localStorage.getItem(PENDING) || '[]') || []).filter(function (p) { return p && p.id && Date.now() - (p.at || 0) < WEEK; }); } catch (_) { return []; }
  }
  function writePending(list) { try { localStorage.setItem(PENDING, JSON.stringify(list.slice(-20))); } catch (_) {} }
  function flushPending() {
    var s = session(), list = readPending();
    if (!s || !list.length) return;
    list.forEach(function (p) {
      if (p.email && p.email !== s.email) return;
      rpc('hoh_stamp_claim', { p_email: s.email, p_pin: s.pin, p_hero: p.id }).then(function (r) {
        if (!r) return;                                   /* no answer: try again on the next visit */
        writePending(readPending().filter(function (x) { return x.id !== p.id; }));
        if (r.ok) adopt(r, s.email);
        if (r.ok && r.claimed) toast('Sent to Jan for your stamp card', 'Jan checks it, then it counts as a stamp.');
      });
    });
  }

  /* ---- 3. Your Hall's stamp card ----------------------------------------------------------------------------------- */
  function adopt(data, email) { state.data = data; state.email = email; state.at = Date.now(); render(); }
  function load(force) {
    if (state.demo) { render(); return; }
    var s = session();
    if (!s) { state.data = null; render(); return; }
    if (!force && state.data && state.email === s.email && Date.now() - state.at < 60000) { render(); return; }
    if (state.busy) return;
    state.busy = true;
    rpc('hoh_stamps', { p_email: s.email, p_pin: s.pin }).then(function (r) {
      state.busy = false;
      if (r && r.ok) adopt(r, s.email); else { state.data = null; render(); }
    });
  }
  function seals(d) {
    var stamps = d.stamps || [], n = stamps.length, base = n ? Math.floor((n - 1) / 6) * 6 : 0, out = '';
    if (n && n % 6 === 0 && (d.in_progress || 0) > 0) base = n;   /* a full page: the next one starts with the portrait being painted */
    for (var k = 0; k < 6; k++) {
      var i = base + k, s = stamps[i], slot = k + 1, next = !s && i === n && (d.in_progress || 0) > 0;
      var img = s ? safeImage(s.image) : '';
      var face = s ? (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" referrerpolicy="no-referrer" style="' + frameStyle(s.frame) + '">' : '<span class="hoh-stamps-initial">' + esc(String(s.name || '?').charAt(0).toUpperCase()) + '</span>')
        : next ? QUILL : '<span class="hoh-stamps-num">' + (i + 1) + '</span>';
      var tier = slot === 6 ? 'page' : slot === 3 ? 'gift' : '';
      out += '<span class="hoh-stamps-seal' + (s ? ' is-on' : '') + (next ? ' is-next' : '') + (tier ? ' is-' + tier : '') + '" title="' + esc(s ? s.name || 'Stamp' : next ? 'Being painted' : tier === 'page' ? 'Hero\u2019s reward' : tier === 'gift' ? 'Free upgrade' : 'Stamp ' + (i + 1)) + '">'
        + face + (tier ? '<i class="hoh-stamps-badge">' + (tier === 'page' ? STAR : GIFT) + '</i>' : '') + '</span>';
    }
    return out;
  }
  function line(d) {
    var n = (d.stamps || []).length, open = (d.rewards || []).filter(function (r) { return !r.used; }).length;
    if (open) return open === 1 ? 'A free upgrade is waiting for your next portrait.' : open + ' free upgrades are waiting for your next portrait.';
    if (!n) return 'Count your FramedFantasy portraits below. Each one Jan adds is a stamp.';
    var nextAt = (Math.floor(n / 3) + 1) * 3, left = nextAt - n;
    return n + ' stamp' + (n === 1 ? '' : 's') + '. ' + left + ' more to ' + (nextAt % 6 === 0 ? 'your Hero\u2019s reward.' : 'a free upgrade on your next portrait.');
  }
  function heroHtml(h) {
    var img = safeImage(h.image), meta = [h.race, h.character_class].filter(Boolean).join(' · ');
    var state_ = h.status === 'checking' ? '<span class="hoh-stamps-pill">With Jan</span>'
      : h.status === 'added' ? '<span class="hoh-stamps-pill is-ok">On your card</span>'
      : h.status === 'set_aside' ? '<span class="hoh-stamps-pill is-no">Not matched</span>'
      : h.status === 'taken' ? '<span class="hoh-stamps-pill is-no">Sent from another order</span>'
      : '<button type="button" class="hoh-stamps-count" data-stamp-count="' + esc(h.hero_id) + '">Count it</button>';
    return '<div class="hoh-stamps-hero"><span class="hoh-stamps-art">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" referrerpolicy="no-referrer" style="' + frameStyle(h.frame) + '">' : '<span class="hoh-stamps-initial">' + esc(String(h.name || '?').charAt(0).toUpperCase()) + '</span>')
      + '<img class="hoh-stamps-ff" src="' + MARK + '" alt="" width="20" height="20"></span>'
      + '<span class="hoh-stamps-name">' + esc(h.name) + '</span>' + (meta ? '<span class="hoh-stamps-meta">' + esc(meta) + '</span>' : '') + state_ + '</div>';
  }
  function cardHtml(d) {
    var n = (d.stamps || []).length, open = (d.rewards || []).some(function (r) { return !r.used; }), heroes = d.heroes || [];
    var cta = open ? (d.has_order ? '<a class="hoh-stamps-cta" href="' + ORDER_PAGE + '">Pick your upgrade on your order page</a>' : '<a class="hoh-stamps-cta" href="' + NEXT_PORTRAIT + '">Order your next portrait</a>') : '';
    return '<section class="hoh-stamps" id="hoh-stamps" aria-labelledby="hoh-stamps-title">'
      + '<div class="hoh-stamps-top"><h2 id="hoh-stamps-title"><img src="' + MARK + '" alt="" width="22" height="22">Your stamp card</h2><span>' + n + ' stamp' + (n === 1 ? '' : 's') + '</span></div>'
      + (state.demo ? '<p class="hoh-stamps-demo">Example card for god mode. Nothing here is real or saved.</p>' : '')
      + '<div class="hoh-stamps-seals">' + seals(d) + '</div>'
      + '<p class="hoh-stamps-line">' + esc(line(d)) + '</p>' + cta
      + (heroes.length ? '<p class="hoh-stamps-sub">Your FramedFantasy portraits</p><div class="hoh-stamps-heroes">' + heroes.map(heroHtml).join('') + '</div>' : '')
      + '<p class="hoh-stamps-note">Only portraits with the FramedFantasy mark count. Jan checks each one before it becomes a stamp. <button type="button" class="hoh-stamp-link" data-stamp-how>How it works</button></p>'
      + '</section>';
  }
  function render() {
    var dash = document.querySelector('#hoh-yh-page .hoh-yh-dash');
    var old = document.getElementById('hoh-stamps'), d = state.data;
    if (!dash || !d || !((d.stamps || []).length || (d.heroes || []).length)) { if (old) old.remove(); return; }
    var focused = document.activeElement && document.activeElement.getAttribute && document.activeElement.getAttribute('data-stamp-count');
    if (old) old.outerHTML = cardHtml(d);
    else {
      var anchor = dash.querySelector('.hoh-yh-add-hero-wrap') || dash.querySelector('.hoh-yh-dash-head');
      if (anchor) anchor.insertAdjacentHTML('afterend', cardHtml(d)); else dash.insertAdjacentHTML('afterbegin', cardHtml(d));
    }
    if (focused) { var again = document.querySelector('[data-stamp-count="' + focused + '"]'); if (again) again.focus(); }
  }
  function count(heroId, button) {
    if (state.demo) {
      (state.data.heroes || []).forEach(function (h) { if (h.hero_id === heroId) h.status = 'checking'; });
      render(); toast('Sent to Jan for your stamp card', 'Example only. Nothing was saved.'); return;
    }
    var s = session(); if (!s) return;
    if (button) { button.disabled = true; button.textContent = 'Sending...'; }
    rpc('hoh_stamp_claim', { p_email: s.email, p_pin: s.pin, p_hero: heroId }).then(function (r) {
      if (r && r.ok) {
        adopt(r, s.email);
        if (r.claimed) toast('Sent to Jan for your stamp card', 'Jan checks it, then it counts as a stamp.');
        else if (r.status === 'already') toast('Already with Jan', 'This portrait was sent before.');
      } else {
        if (button) { button.disabled = false; button.textContent = 'Count it'; }
        toast('That did not go through', r && r.status === 'too_many' ? 'Too many tries. Wait 15 minutes, then try again.' : 'Please sign in to Your Hall again, then try once more.');
      }
    });
  }

  /* ---- 4. How the stamp card works --------------------------------------------------------------------------------- */
  function howOpen() {
    if (document.getElementById('hoh-stamp-how')) return;
    var opener = document.activeElement;
    document.body.insertAdjacentHTML('beforeend', '<div class="hoh-stamp-how" id="hoh-stamp-how" role="dialog" aria-modal="true" aria-labelledby="hoh-stamp-how-title">'
      + '<div class="hoh-stamp-how-box">'
      + '<div class="hoh-stamp-how-seals" aria-hidden="true"><span class="is-on"></span><span class="is-on"></span><span class="is-gift">' + GIFT + '</span><span></span><span></span><span class="is-page">' + STAR + '</span></div>'
      + '<h3 id="hoh-stamp-how-title">How your stamp card works</h3>'
      + '<ol class="hoh-stamp-how-steps">'
      + '<li><b>Add your portrait to the Hall.</b> Tick the FramedFantasy box when you add it.</li>'
      + '<li><b>Jan checks it by hand.</b> Each FramedFantasy portrait Jan adds is a stamp. Portraits Jan paints for you count too.</li>'
      + '<li><b>Every 3rd stamp earns a free upgrade.</b> Pick one size up, Living Motion, a custom background or a pet for your next portrait.</li>'
      + '<li><b>The 6th stamp is the Hero\u2019s reward.</b> It can take a Thigh-Up all the way to Full-Body.</li>'
      + '</ol>'
      + '<p class="hoh-stamp-how-foot">Your card lives in Your Hall and on your order page.</p>'
      + '<button type="button" class="hoh-btn-primary hoh-stamp-how-close" data-stamp-how-close>Got it</button>'
      + '</div></div>');
    var box = document.getElementById('hoh-stamp-how');
    requestAnimationFrame(function () { box.classList.add('is-open'); });
    box.querySelector('[data-stamp-how-close]').focus();
    box._opener = opener;
  }
  function howClose() {
    var box = document.getElementById('hoh-stamp-how'); if (!box) return;
    var opener = box._opener; box.remove();
    if (opener && opener.focus) { try { opener.focus(); } catch (_) {} }
  }

  /* ---- 5. Add it to the Hall, with the box ticked ----------------------------------------------------------------------- */
  function openFromHash() {
    if (location.hash !== '#add-ff-portrait') return;
    var tries = 0;
    (function wait() {
      if (typeof window.hohOpenForm !== 'function') { if (++tries < 100) setTimeout(wait, 100); return; }
      try { history.replaceState(null, '', location.pathname + location.search); } catch (_) {}
      window.hohOpenForm();
      var ticks = 0;
      (function tick() {
        var box = ffBox();
        if (!box) { if (++ticks < 50) setTimeout(tick, 100); return; }
        if (!box.checked) { box.checked = true; box.dispatchEvent(new Event('change', { bubbles: true })); }
        syncSoon();
      })();
    })();
  }

  /* ---- Wiring -------------------------------------------------------------------------------------------------------- */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.id === 'hoh-f-ff-portrait') syncSoon();
    if (t && t.id === 'hoh-stamp-count') state.countIt = !!t.checked;
  });
  document.addEventListener('click', function (e) {
    var how = e.target.closest && e.target.closest('[data-stamp-how]'); if (how) { e.preventDefault(); howOpen(); return; }
    var close = e.target.closest && e.target.closest('[data-stamp-how-close]'); if (close) { howClose(); return; }
    if (e.target.id === 'hoh-stamp-how') { howClose(); return; }
    var c = e.target.closest && e.target.closest('[data-stamp-count]'); if (c && !c.disabled) count(c.getAttribute('data-stamp-count'), c);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && document.getElementById('hoh-stamp-how')) howClose(); });
  /* The FramedFantasy confirm's "Nevermind" unticks the box without a change event, and the form redraws its steps. */
  if (typeof window.hohFfConfirmCancel === 'function') {
    var cancel = window.hohFfConfirmCancel;
    window.hohFfConfirmCancel = function () { var r = cancel.apply(this, arguments); syncSoon(); return r; };
  }
  function watch() {
    var form = document.getElementById('hoh-form-inner');
    if (form && !form._hohStamps) { form._hohStamps = true; new MutationObserver(syncSoon).observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] }); }
    var page = document.getElementById('hoh-yh-page');
    if (page && !page._hohStamps) {
      page._hohStamps = true;
      new MutationObserver(function () { if (!document.getElementById('hoh-stamps') && document.querySelector('#hoh-yh-page .hoh-yh-dash')) load(false); }).observe(page, { childList: true, subtree: true });
    }
  }
  document.addEventListener('hoh:hero-submitted', function (e) {
    var d = e.detail || {};
    if (!d.ff || !d.id || !state.countIt || d.portal) return;
    writePending(readPending().concat([{ id: String(d.id), email: String(d.email || '').toLowerCase(), at: Date.now() }]));
    setTimeout(flushPending, 400);
  });
  document.addEventListener('hoh:signed-in', function () { flushPending(); load(true); });
  document.addEventListener('hoh:characters-loaded', function () { watch(); load(false); });

  function start() {
    watch();
    if (/[?&]stampdemo\b/.test(location.search) && god()) {
      state.demo = true;
      var cdn = 'https://cdn.shopify.com/s/files/1/0884/2389/1261/files/';
      var hero = function (id, name, race, cls, file, status) { return { hero_id: id, name: name, race: race, character_class: cls, image: cdn + file + '&width=480', frame: { x: 50, y: 24, zoom: 100 }, status: status }; };
      state.data = { ok: true, has_order: false, in_progress: 0, rewards: [],
        stamps: [{ n: 1, kind: 'older', name: 'Vorrak', image: cdn + 'Cullen_Dragonborn_v2_HD.webp?v=1780790187&width=240', frame: { x: 50, y: 24, zoom: 100 } },
                 { n: 2, kind: 'older', name: 'Nyx', image: cdn + 'Jax_Ashworth_1.jpg?width=240', frame: { x: 50, y: 24, zoom: 100 } }],
        heroes: [hero('d1', 'Vorrak', 'Dragonborn', 'Paladin', 'Cullen_Dragonborn_v2_HD.webp?v=1780790187', 'added'),
                 hero('d2', 'Nyx', 'Tiefling', 'Warlock', 'Jax_Ashworth_1.jpg?v=1', 'added'),
                 hero('d3', 'Brother Osric', 'Human', 'Monk', 'Raven_v2_HD.webp?v=1779365848', null),
                 hero('d4', 'Captain Elaris', 'Elf', 'Fighter', 'Trace_V2_HD_Final_Revision_3.webp?v=1747883884', 'checking')] };
      if (typeof window.hohOpenYourHall === 'function') { try { window.hohOpenYourHall(); } catch (_) {} }
    }
    openFromHash();
    flushPending();
    load(false);
  }
  window.hohStamps = { load: load, render: render, how: howOpen, sync: syncPanel };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
